export default [
  {
    type: 'Container',
    bleed: true,
    style: 'emphasis',
    items: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 'stretch',
            items: [
              {
                type: 'ColumnSet',
                spacing: 'None',
                columns: [
                  {
                    type: 'Column',
                    items: [
                      {
                        type: 'TextBlock',
                        text: 'Individuals',
                        spacing: 'None',
                      },
                    ],
                    width: 'stretch',
                    spacing: 'Small',
                  },
                ],
              },
              {
                type: 'TextBlock',
                text: '{{formattedIdCount}}',
                color: 'Accent',
                size: 'Large',
                weight: 'Lighter',
                spacing: 'None',
              },
            ],
            separator: false,
          },
          {
            type: 'Column',
            width: 'stretch',
            items: [
              {
                type: 'ColumnSet',
                spacing: 'None',
                columns: [
                  {
                    type: 'Column',
                    items: [
                      {
                        type: 'TextBlock',
                        text: 'Households',
                        spacing: 'None',
                      },
                    ],
                    width: 'stretch',
                    spacing: 'Small',
                  },
                ],
              },
              {
                type: 'TextBlock',
                text: '{{formattedHhCount}}',
                color: 'Accent',
                size: 'Large',
                weight: 'Lighter',
                spacing: 'None',
              },
            ],
            separator: false,
          },
          {
            type: 'Column',
            width: 'stretch',
            items: [
              {
                type: 'ColumnSet',
                spacing: 'None',
                columns: [
                  {
                    type: 'Column',
                    items: [
                      {
                        type: 'TextBlock',
                        text: 'Devices',
                        fontType: 'Default',
                      },
                    ],
                    width: 'stretch',
                    spacing: 'Small',
                  },
                ],
              },
              {
                type: 'TextBlock',
                text: '{{formattedDeviceCount}}',
                color: 'Accent',
                size: 'Large',
                weight: 'Lighter',
                spacing: 'None',
              },
            ],
            separator: false,
          },
        ],
      },
    ],
  },
];
